import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { page } from '../index'
import {
	ExternalComponentDsApiSymbol,
	ExternalComponentDsPublicApiSymbol,
	ExternalComponentLoaderSymbol,
	PartytownLoaderSymbol,
	TrustedExternalComponentLoaderSymbol,
	UntrustedExternalComponentLoaderSymbol,
	PreventRendererNotSupportedSymbol,
} from '../symbols'
import { EditorPartytownLoader } from './editorPartytownLoader'
import { ExternalComponentLoader } from '../componentsLoader/externalComponentLoader'
import { TrustedExternalComponentLoader } from '../componentsLoader/trustedExternalComponentLoader'
import { UntrustedExternalComponentLoader } from '../componentsLoader/untrustedExternalComponentLoader'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { UpdateExternalComponentFactory } from './updateExternalComponent'
import { ExternalComponentDsApiFactory } from './externalComponentDsApi.ts'
import { ExternalComponentDsApiFactoryFactory } from './externalComponentDsPublicApi'
import { preventRendererNotSupportedFactory } from './preventRendererNotSupported'

export const editorPage = page

export const editor: ContainerModuleLoader = (bind) => {
	bind(PartytownLoaderSymbol).to(EditorPartytownLoader)

	bind(TrustedExternalComponentLoaderSymbol).to(TrustedExternalComponentLoader)
	bind(UntrustedExternalComponentLoaderSymbol).to(UntrustedExternalComponentLoader)
	bind(ExternalComponentLoaderSymbol).to(ExternalComponentLoader)

	bind(ModelUpdatesHandlersImplementor).to(UpdateExternalComponentFactory)
	bind(ExternalComponentDsApiSymbol).to(ExternalComponentDsApiFactory)
	bind(ExternalComponentDsPublicApiSymbol).to(ExternalComponentDsApiFactoryFactory)
	bind(PreventRendererNotSupportedSymbol).to(preventRendererNotSupportedFactory)
}
